import React from 'react';
import { Link } from 'react-router-dom';
import './AboutBanner.scss';
import bannerOne from '../../assets/about/banner/banner_1.png'
import bannerTwo from '../../assets/about/banner/banner_2.png'
import pattern from '../../assets/banner/pattern.png'

const AboutBanner = () => {
    return (
        <section className='about-section' data-aos="fade-up" data-aos-duration="2000">
        <div className="d-table">
            <div className="d-table-cell">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            <div className="about-banner-text">
                                <h2>About Us</h2>
                                <p>Dr tanwar dental clinic is a team of specialists which give edge in dental practice & interdisciplinary approach,Dr bhagat tanwar is MDS Endodontist ( root canal specialist) and implantologist
                                Dr poorna tanwar is MDS orthodontist and implantologist.</p>
    
                                <div className="theme-btn">
                                    <Link to='/'>Contact Us</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="about-banner-img">
                                {/* <img src="https://lh3.googleusercontent.com/p/AF1QipNe0vscJ2xwNjQDGjo1r1NDLJ89Uau0NBdjJhmA=s1360-w1360-h1020-rw" alt="about banner"/> */}
                                
                                {/* Embedded YouTube video */}
                                <iframe 
                                    width="100%" 
                                    height="315" 
                                    src="https://www.youtube.com/embed/2l60gB4bsCM" 
                                    title="YouTube video player" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen>
                                </iframe>
                                
                                <img className='pattern' src={pattern} alt="about banner two"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    );
};

export default AboutBanner;